<template>
  <div class="IndexTop" style="background: #007AFF;color: #FFFFFF;">
     <el-col :span="24">
       <p class="IndexTop_title" style="padding-right: 15px;padding-left: 15px;">
       <el-link  font-size="120px;"  style='float: right;margin-top: 0px;right: 300px; ' href="https://doc.weixin.qq.com/sheet/e3_ADMALgZsABk9adRHwqRSHOHTN7c4X?scode=ADYAvAfWAA0ANun4QgADMALgZsABk&tab=BB08J2" target="info">门店小程序二维码 <i class="el-icon-view el-icon--right"></i></el-link>
       {{name}}门店--排场系统
       <el-button type="danger" @click='sign_out' class='' style='float: right;margin-top: 20px;margin-right: -70px;' >退出</el-button>

       </p>
     </el-col>
  </div>
</template>


<script>
import {
      get_shop_data
    } from "@/assets/js/network/request";
    import {
      gAccount
    } from "@/assets/js/data/Account";
export default {
  components: {
  },
  data() {
    return {
      name:""
    };
  },
  methods: {
    sign_out(){
      this.$cookies.set("m_token_p",null, -1);
      this.$cookies.set("m_token_n",null, -1);
      this.$router.push({
        path: "/"
      });
    }
  },
  mounted() {
    this.name=gAccount.get_Account_shop().name;
  },
};
</script>

<style scoped>
.IndexTop{
  height: 80px;
  line-height: 80px;
  	background: -webkit-linear-gradient(left, #092f5c, #26183c) !important;
  	/* Safari 5.1 - 6.0 */
  	background: -o-linear-gradient(right, #092f5c, #26183c) !important;
  	/* Opera 11.1 - 12.0 */
  	background: -moz-linear-gradient(right, #092f5c, #26183c) !important;
  	/* Firefox 3.6 - 15 */
  	background: linear-gradient(to right, #092f5c, #26183c) !important;
  	/* 标准的语法 */
}
.IndexTop_title{
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/IndexTop.vue